<div class="wrapper"
     data-automation-e2e-selector="sealedBidToggle"
     *ngIf="isShown | async">
    <label class="label"
          data-automation-e2e-selector="toggleLabel"
          for="sealedBid">
        Sealed Bid
    </label>
    <div class="toggle"
         data-automation-e2e-selector="toggleSwitcher">
        <input type="checkbox"
               name="sealedBid"
               id="sealedBid"
               checked
               #chk
               [ngModel]="checked | async"
               (change)="change.next(chk.checked)"
               class="checkbox"
               data-automation-e2e-selector="toggleIndicator">
        <label class="innerLabel"
               for="sealedBid">
        </label>
    </div>
</div>
